import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { Constantes } from '../constantes';

import { AutenticacionService } from './autenticacion.service';

import { Mensaje } from '../models/mensaje';

@Injectable()
export class IpGuard implements CanActivate, CanActivateChild {

  constructor(private autenticacionService: AutenticacionService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.autenticacionService.validarIp()
      .map(
      (data) => {
        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          return true;
        } else {
          this.router.navigate(['/pagina-error']);
          return false;
        }
      }
      ).catch(error => {
        this.router.navigate(['/pagina-error']);
        return Observable.of(false);
      });
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/services/ip-guard.service.ts